import React from "react";
import { logo, newCrypto } from "../../assets/images";

/**
 * Left-hand marketing panel, shown from `lgss` up. Same copy as the old
 * Register.tsx, but the fixed `mt-72 lg:mt-52` magic margins are replaced with
 * a flex column so the card sits correctly at every width.
 */
const AuthBrandPanel = () => {
  return (
    <aside className="sticky top-0 hidden h-screen w-2/5 shrink-0 flex-col bg-hero bg-cover bg-center px-[45px] py-[25px] font-manrope text-white lgss:flex">
      <img src={logo} className="h-[29px] w-[110px]" alt="Deexoptions" />

      <div className="flex flex-1 items-end pb-6">
        <div className="w-full overflow-hidden rounded-xl border border-white/10 bg-[#010D16]">
          <img src={newCrypto} alt="" className="w-full rounded-t-xl" />
          <div className="px-8 py-5">
            <p className="text-[13px] font-semibold tracking-wider text-[#60B7F6]">
              NO LIMITS
            </p>
            <h2 className="mt-1 text-[18px] font-bold leading-snug text-white">
              Receive payments in Cryptocurrency
            </h2>
            <p className="mt-2 text-[14px] font-medium leading-relaxed text-[#617889]">
              Get rid of all forms of payment limitations by opening a gateway
              to receive payments in Cryptocurrency from customers. Receive
              Bitcoin, Ethereum or USDT where there is no cash.
            </p>
          </div>
        </div>
      </div>
    </aside>
  );
};

export default AuthBrandPanel;
